import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import useStyles from './makeStyles';

const BulkDownloadLink = ({ pdf }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const downloadAll = () => {
    if (pdf.length) {
      pdf.forEach((item) => {
        const link = document.createElement('a');
        const parts = item.publicPath.split('/');
        const lastPart = parts[parts.length - 1];
        link.href = item.url;
        link.download = lastPart;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.click();
      });
    }
  };

  return (
    <div>
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <a
        href="#"
        onClick={downloadAll}
        download
      >
        <p className={classes.linkText}>{t('paymentConfirmation.downloadAll')}</p>
      </a>
    </div>
  );
};

BulkDownloadLink.propTypes = {
  pdf: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default BulkDownloadLink;
